import { getBackendUrl } from "../App.vue";

// Reload this tab when the backend has been redeployed since the bundle loaded.
//
// Old bundles kept running in open tabs for days after a release, still
// calling endpoints with pre-release semantics (the 2026-09 logout change is
// the motivating case). The backend exposes /api/build; we remember the value
// at load and compare whenever the tab becomes visible, and every five
// minutes while it is. A change means a deploy happened: reload once.
//
// Network errors are ignored — a flaky connection must never trigger a
// reload loop — and a reload only happens on a *different* value, never on
// the first read.

const INTERVAL_MS = 5 * 60 * 1000;
let known = null;
let started = false;

async function currentBuild() {
    try {
        const res = await fetch(`${getBackendUrl()}/api/build`, { cache: "no-store", credentials: "include" });
        if (!res.ok) return null;
        const data = await res.json();
        return data && typeof data.build === "string" && data.build ? data.build : null;
    } catch (_) {
        return null;
    }
}

async function check() {
    const build = await currentBuild();
    if (!build) return;
    if (known === null) {
        known = build;
        return;
    }
    if (build !== known) {
        console.info("[build] backend redeployed, reloading this tab");
        window.location.reload();
    }
}

export function startBuildWatch() {
    if (started || typeof window === "undefined") return;
    started = true;
    check();
    setInterval(check, INTERVAL_MS);
    document.addEventListener("visibilitychange", () => {
        if (document.visibilityState === "visible") check();
    });
}
